import React from "react";
import appConfig from "../environment/environments";

export default function Error() {
  const styles = {
    textDecoration: "none",
    padding: "13px 20px",
    backgroundColor: "#262c43",
    color: "#ffffff",
    fontSize: "16px",
  };
  const container = {
    padding: "30px",
  };
  const idToken = localStorage.getItem("msal.idtoken");
  return (
    <div style={container}>
      <p>
        You do not have permissions to access this application. You can check
        the applications you have access to on the Carrier Apps Hub
      </p>
      <br />
      <br />
      <a
        style={styles}
        href={appConfig.api.umDashboardNavigation + "?umtoken=" + idToken}
      >
        Open Carrier Apps Hub
      </a>
    </div>
  );
}
